import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import $ from '~/helpers/$';
import { PageTitleConfirmation } from './announce-page-title';
import { assertNotNull, assertDefined } from '~/helpers/data';
import useLinkHandler from './router-helpers/use-link-handler';
import { RouterContextProvider } from './router-context';
import useLayoutContext, { LayoutContextProvider } from '~/contexts/layout';
import { ImportedPage } from './router-helpers/page-loaders';
import { HomePage, ErrataRoutes, DetailsRoutes, OtherPageRoutes } from './router-helpers/page-routes';
import './skip-to-content.scss';
function doSkipToContent(event) {
    event.preventDefault();
    const mainEl = document.getElementById('main');
    const target = assertDefined(assertNotNull(mainEl === null || mainEl === void 0 ? void 0 : mainEl.querySelector($.focusable)));
    $.scrollTo(target);
    target.focus();
}
function SkipToContent() {
    return (React.createElement("a", { className: "skiptocontent", href: "#main", onClick: doSkipToContent }, "skip to main content"));
}
export default function Router() {
    const linkHandler = useLinkHandler();
    const { origin } = window.location; // React-Router Location does not have origin
    const { pathname } = useLocation();
    const canonicalUrl = `${origin}${pathname}`;
    useEffect(() => {
        document.addEventListener('click', linkHandler);
        return () => document.removeEventListener('click', linkHandler);
    }, [linkHandler]);
    useEffect(() => {
        if ('piTracker' in window && window.piTracker instanceof Function) {
            window.piTracker(canonicalUrl);
        }
    }, [canonicalUrl]);
    return (React.createElement(RouterContextProvider, null,
        React.createElement(PageTitleConfirmation, null),
        React.createElement(SkipToContent, null),
        React.createElement(LayoutContextProvider, null,
            React.createElement(MainRoutes, null))));
}
const FOOTER_PAGES = [
    'license',
    'tos',
    'privacy',
    'privacy-policy',
    'accessibility-statement',
    'careers'
].map((s) => `/${s}/`);
function MainRoutes() {
    const { Layout } = useLayoutContext();
    return (React.createElement(Layout, null,
        React.createElement(Routes, null,
            React.createElement(Route, { index: true, element: React.createElement(HomePage, null) }),
            FOOTER_PAGES.map((path) => (React.createElement(Route, { path: path, key: path, element: React.createElement(ImportedPage, { name: "footer-page" }) }))),
            React.createElement(Route, { path: "/errata/*", element: React.createElement(ErrataRoutes, null) }),
            React.createElement(Route, { path: "/details/*", element: React.createElement(DetailsRoutes, null) }),
            React.createElement(Route, { path: "/:dir/*", element: React.createElement(OtherPageRoutes, null) }))));
}
